var ProductGroupHelper = /** @class */ (function () {
    function ProductGroupHelper() {
    }
    ProductGroupHelper.buildBreadcrumb = function (productGroupId, flatProductGroups) {
        var result = null;
        var productGroup = flatProductGroups[productGroupId];
        if (productGroup) {
            if (productGroup.childrenIds && productGroup.childrenIds.length && productGroup.childrenIds.length > 0) {
                result = {
                    sequence: [],
                    filter: []
                };
                ProductGroupHelper.buildSequence(productGroup.id, result.sequence, flatProductGroups);
                productGroup.childrenIds.forEach(function (productGroupId) {
                    result.filter.push(flatProductGroups[productGroupId]);
                });
                result.sequence.reverse();
            }
            else {
                result = {
                    sequence: [],
                    filter: []
                };
                ProductGroupHelper.buildSequence(productGroup.id, result.sequence, flatProductGroups);
                if (productGroup.siblingIds && productGroup.siblingIds.length && productGroup.siblingIds.length > 0) {
                    productGroup.siblingIds.forEach(function (productGroupId) {
                        result.filter.push(flatProductGroups[productGroupId]);
                    });
                }
                result.sequence.reverse();
            }
            if (result.filter.length === 0) {
                result.filter = null;
            }
        }
        return result;
    };
    ProductGroupHelper.buildSequence = function (productGroupId, sequence, flatPackageProductGroups) {
        if (flatPackageProductGroups[productGroupId].parentId) {
            if (flatPackageProductGroups[flatPackageProductGroups[productGroupId].parentId].name !== 'root') {
                sequence.push(flatPackageProductGroups[flatPackageProductGroups[productGroupId].parentId]);
                ProductGroupHelper.buildSequence(flatPackageProductGroups[productGroupId].parentId, sequence, flatPackageProductGroups);
            }
        }
    };
    return ProductGroupHelper;
}());
export default ProductGroupHelper;
